import fp from 'lodash/fp';
import React from 'react';
import { Breadcrumb, BreadcrumbItem } from "react-bootstrap";
import { connect } from 'react-redux';
import { LinkContainer } from "react-router-bootstrap";
import { branch, lifecycle, mapProps, renderComponent, withProps } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import { routes } from '../../../../constants';
import { adminActions } from '../../../../state/modules/admin';
import Loading from '../../loading';
import ProgressReport from '../../shared/progress-report';

const reportBreadCrumb =
  <Breadcrumb>
    <LinkContainer to={routes.adminPortal.root}>
      <BreadcrumbItem>
        Admin portal
      </BreadcrumbItem>
    </LinkContainer>
    <BreadcrumbItem active>
      Progress Report
    </BreadcrumbItem>
  </Breadcrumb>

const mapStateToProps = (state) => ({
  report: state.admin.report
})

const mapDispatchToProps = (dispatch) => ({
  getUserReport: bindActionCreators(adminActions.admin.getReport, dispatch)
})

export default compose(
  withProps(({
    match: {
      params: {
        user,
        yearsFromNow
      }
    }
  }) => ({
    reporteeId: parseInt(user, 10),
    yearsFromNow: parseInt(yearsFromNow, 10)
  })),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const {
        getUserReport,
        reporteeId,
        yearsFromNow
      } = this.props;

      getUserReport(reporteeId, yearsFromNow);
    }
  }),
  branch(
    ({ report }) => !report,
    renderComponent(Loading)
  ),
  mapProps(
    ({ report }) => ({
      afsLicence: report.afsLicence,
      cpdActivity: report.cpdActivity,
      cpdDaysRemaining: report.cpdDaysRemaining,
      user: {
        ...fp.get('user')(report),
        ...fp.get('user.user')(report)
      },
      cpdCategoryProgress: report.cpdCategoryProgress,
      defaultProgressLabel: fp.get('userIndustry.defaultProgressLabel')(report),
      filter: report.filter,
      reportBreadCrumb,
      goals: report.goals
    })
  )
)(ProgressReport);


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/user-portal/user-progress-report.js